import store from 'store'

// Submits a POST form to an external URL, opening the result in a new tab.
// Used for legacy-system deep links that require POSTed hidden fields (which a
// normal <a> link / navigation can't do).
export function submitExternalForm({ action, fields = {}, target = '_blank', method = 'POST' }) {
  const form = document.createElement('form')
  form.method = method
  form.action = action
  form.target = target
  form.style.display = 'none'

  Object.entries(fields).forEach(([name, value]) => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value ?? ''
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
  form.remove()
}

// Launches an external-form menu item. When `tokenAction` is set, it dispatches that
// thunk first and uses its response ({ link, token, selcamp }) for the action + fields;
// otherwise it uses the static action/fields. The target tab is opened synchronously
// (before the await) so it isn't popup-blocked once the token request resolves.
export async function launchExternalForm({ tokenAction, action, fields = {}, target = '_blank', method = 'POST' }) {
  const windowName = target === '_blank' ? 'externalForm' : target
  const win = window.open('', windowName)

  try {
    let finalAction = action
    let finalFields = fields

    if (tokenAction) {
      const { link, token, selcamp } = await store.dispatch(tokenAction()).unwrap()
      finalAction = link
      finalFields = { token, selcamp }
    }

    submitExternalForm({ action: finalAction, fields: finalFields, target: windowName, method })
  } catch (err) {
    win?.close()
    throw err
  }
}
